import { render, staticRenderFns } from "./ListProduct.vue?vue&type=template&id=32115dd2&scoped=true"
import script from "./ListProduct.vue?vue&type=script&lang=ts"
export * from "./ListProduct.vue?vue&type=script&lang=ts"
import style0 from "./ListProduct.vue?vue&type=style&index=0&id=32115dd2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../nguonhangchina/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32115dd2",
  null
  
)

export default component.exports